module.exports = __webpack_public_path__ + "static/media/AU Research Roster - mini.9fb27d6f.csv";